import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { assetImages } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import { formatTime } from "../format/time";

const LoadingModal = ({ open, onClose, timer = "0:23" }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 400); // Change dots every 500ms

    return () => clearInterval(interval); // Cleanup the interval
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: `linear-gradient(to bottom, ${darkColors.popupBgTop}, ${darkColors.popupBgBottom}`,
          borderRadius: "12px",
          maxWidth: "420px",
          width: "100%",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
          <Box
            component={"img"}
            src={assetImages.microscope}
            alt="loading..."
            height={90}
            width={90}
          />

          <Typography
            fontWeight={700}
            fontSize={
              isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
            }
            mt={4}
            color="white"
          >
            Finding Match{dots}
          </Typography>

          <Typography mt={1} color="white" fontSize={fontSizes.heading3}>
            {formatTime(timer)}
          </Typography>

          <Box
            sx={{
              mt: 4,
              mb: 2,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={onClose}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: darkColors.buttonTop,
                fontSize: isMediumScreen
                  ? fontSizes.heading3
                  : fontSizes.heading2,
                cursor: "pointer",
                fontFamily: "MontserratBold",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;
